import React from 'react'
import { Row, Col } from 'reactstrap';
import { Dialog } from 'primereact/dialog';
import { ConfigServer } from '../../data/config'
import '../Invoice/dialogStyle.css'

export const DialogPreviewComplementPayment = (props) => {

	const {
		showPreview, setShowPreview, formComplement, listCommercialLines, clientInformation, listInvoices, datECurrentTime, serie
	} = props;

	const emisor = listCommercialLines?.find(c => c.value == formComplement?.commercialLineId);
	const receptor = clientInformation?.listCompanyBusinessNames?.find(c => c.id_company_business_name == formComplement?.companyBusinessNameId);

	return (
		<Dialog
			visible={showPreview}
			modal
			onHide={() => setShowPreview(false)}
			style={{
				width: '90vw',
				maxWidth: '1200px'
			}}

			className="complementPayment-dialog"

		>
			<div className="complementPayment-container">

				{/* ENCABEZADO */}
				<Row className="complementPayment-header">
					<Col sm="4" style={{ textAlign: 'center' }}>
						<img src={ConfigServer.serverUrl + "/api/Configuration/Logo"} style={{ width: "65%", borderRadius: '8px' }} alt="Invoice" />
					</Col>
					<Col sm="8" style={{ textAlign: 'center' }}>
						<div className="complementPayment-companyName">{emisor?.label ?? ''}</div>
						<div className="complementPayment-companyInfo">RFC: {emisor?.rfc ?? ''}</div>
						<div className="complementPayment-companyInfo">{emisor?.code_tax_regime ?? ''}-{emisor?.name_tax_regime ?? ''}</div>
						<div className="complementPayment-companyInfo">{emisor?.address ?? ''}, {emisor?.colony ?? ''}, C.P. {emisor?.cpBranch ?? ''}</div>

					</Col>
				</Row>


				<Row style={{ marginBottom: '20px' }}>
					<Col sm="5"
						className="complementPayment-card"
						style={{ backgroundColor: "#def2ff14" }}
					>
						<div className="complementPayment-cardTitle">

							RECEPTOR
						</div>
						<p style={{ fontSize: '11px', margin: '2px 0' }}>
							<strong>{receptor?.business_name ?? ''}</strong>
						</p>
						<p style={{ fontSize: '11px', margin: '2px 0' }}>
							<strong>RFC:</strong> {receptor?.rfc ?? ''}
						</p>
						<p style={{ fontSize: '11px', margin: '2px 0' }}>
							<strong>Domicilio:</strong> {receptor?.cp ?? ''}
						</p>

					</Col>

					<Col sm="7" className="complementPayment-card" style={{ backgroundColor: "#def2ff14" }}>
						<div className="complementPayment-cardTitle">
							Datos de la factura
						</div>
						<Row style={{ fontSize: '12px', textAlign: 'left', lineHeight: '1.3' }}>
							<Col sm="6">
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Sucursal:</strong> {serie.length > 0 ? serie[0].branch ?? 'N se a registrado una configuracion ' : "N/A"}
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Serie:</strong> {serie.length > 0 ? serie[0].serie ?? 'No se a registrado una configuracion ' : "N/A"}
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Lugar de expedición:</strong> {emisor?.cpBranch ?? ''}
									{/* {receptor?.cp ?? ''} */}
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Fecha de expedición:</strong> {datECurrentTime}
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>No. de Certificado:</strong> XXXXXXXXXXXXXXXXXXXX
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Tipo:</strong> P
								</p>
							</Col>
							<Col sm="6">
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Método de pago:</strong> -0
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Forma de pago:</strong> -0
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Uso CFDI:</strong>  CP01-Pagos
								</p>
								<p style={{ fontSize: '11px', margin: '2px 0' }}>
									<strong>Moneda:</strong>  XXX-Los códigos asignados para las transacciones en que intervenga ninguna moneda
								</p>
							</Col>
						</Row>
					</Col>
				</Row>


				<Row style={{ marginBottom: '20px' }}>
					<Col sm="12" className="complementPayment-card" >
						<div className="complementPayment-cardTitle" >COMPLEMENTO DE PAGO VERSIÓN 2.0</div>
						<table className="complementPayment-table">
							<tbody>
								<tr style={{ backgroundColor: '#fafafa' }}>
									<td style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 'bold' }}>Fecha de Pago:</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{formComplement?.paymentDate ?? ''}</td>

									<td style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 'bold' }}>Forma de pago:</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{formComplement?.paymentFormId ?? ''}</td>

									<td style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 'bold' }}>Monto:</td>
									{listInvoices?.length > 0 && (
										<td style={{ border: '1px solid #ccc', padding: '6px' }}>
											{(listInvoices[0].amount && listInvoices[0].amount !== "0")
												? Number(listInvoices[0].amount).toLocaleString('es-MX', { minimumFractionDigits: 2 })
												: listInvoices[0].outside_balance.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
										</td>
									)}


								</tr>
								<tr style={{ backgroundColor: '#f9f9f9' }}>
									<td style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 'bold' }}>Moneda:</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{listInvoices?.[0]?.code_coin ?? ''}</td>

									<td style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 'bold' }}>Tipo de Cambio:</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{listInvoices?.[0]?.type_change ?? ''}</td>

									<td style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 'bold' }}>Número de Operación:</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{listInvoices?.[0]?.parciality_number ?? ''}</td>
								</tr>
							</tbody>
						</table>

					</Col>
				</Row>

				<Row>
					<Col sm="12" className="complementPayment-card" >
						<div className="complementPayment-cardTitle">DOCUMENTOS RELACIONADOS</div>
						<table className="complementPayment-table">
							<tbody>
								<tr style={{ backgroundColor: '#f0f8ff' }}>
									<td colSpan={6} style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 'bold', color: '#0d3b59' }}>UUID Documento Relacionado:</td>
									<td colSpan={6} style={{ border: '1px solid #ccc', padding: '6px' }}>{listInvoices?.[0]?.uuid ?? ''}</td>
								</tr>
								<tr style={{ backgroundColor: '#f9f9f9' }}>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Serie</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Folio</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>MonedaDR</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>T. C.</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Método de Pago</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Parcialidad</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Saldo Ant</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Pagado</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Insoluto</th>
								</tr>
								<tr>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{listInvoices?.[0]?.serie ?? ''}</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{listInvoices?.[0]?.folio ?? ''}</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{listInvoices?.[0]?.code_coin ?? ''}</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}></td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}></td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}></td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>{listInvoices?.[0]?.outside_balance ?? ''}</td>
									{listInvoices?.length > 0 && (
										<td style={{ border: '1px solid #ccc', padding: '6px' }}>
											{(listInvoices[0].amount && listInvoices[0].amount !== "0")
												? Number(listInvoices[0].amount).toLocaleString('es-MX', { minimumFractionDigits: 2 })
												: listInvoices[0].outside_balance.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
										</td>
									)}

									<td style={{ border: '1px solid #ccc', padding: '6px' }}></td>
								</tr>
							</tbody>
						</table>
					</Col>
				</Row>

				<Row>
					<Col sm="12" className="complementPayment-card">
						<div className="complementPayment-cardTitle">IMPUESTO DEL PAGO</div>
						<table className="complementPayment-table">
							<tbody>
								<tr style={{ backgroundColor: '#f0f8ff' }}>
									<td colSpan={12} style={{ border: '1px solid #ccc', padding: '6px', fontWeight: 'bold', color: '#0d3b59' }}>Traslado Base: &nbsp;&nbsp;&nbsp;  Impuesto: 002 &nbsp;&nbsp; Factor: Tasa &nbsp;&nbsp; Tasa: 0.160000 &nbsp;&nbsp; Importe: {listInvoices?.[0]?.total_taxes ?? ''}</td>
								</tr>

							</tbody>
						</table>
					</Col>
				</Row>


				<Row>
					<Col sm="12" className="complementPayment-card">
						<table className="complementPayment-table">
							<tbody>

								<tr style={{ backgroundColor: '#f9f9f9' }}>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Cantidad</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Código</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Clv-Unidad</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Clv-Concepto</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>P. Unitario</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Importe</th>
									<th style={{ border: '1px solid #ccc', padding: '6px' }}>Descuento</th>
								</tr>
								<tr>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>1</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}></td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>ACT</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>84111506-Pago</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>0</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}>0</td>
									<td style={{ border: '1px solid #ccc', padding: '6px' }}></td>

								</tr>
							</tbody>
						</table>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col sm="6" className="complementPayment-card">
						<div style={{
							border: '1px solid #ccc',
							padding: '6px',
							fontWeight: 'bold',
							color: '#181818ff',
							textAlign: 'left',
							lineHeight: '1.6'
						}}>
							Folio Fiscal: XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX <br />
							Fecha y hora de certificación:  <br />
							Lugar de expedición: {emisor?.cpBranch ?? ''}
						</div>
					</Col>
				</Row>

				<Row className='mt-4'>
					<Col sm="12" className='p-l-0 p-r-0 text-center' >
						<span className="complementPayment-footerText">*Este Documento es una Representación  de un CFDI</span>
						<br />
						<span className='txt-secondary text-uppercase'>*Impuesto Retenido de Conformidad con el Impuesto al Valor Agregado</span>
					</Col>
				</Row>


			</div>
		</Dialog>
	)
}
